import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import { E_WALLET_TAB, E_WALLET_FILTER } from '@/utils/constants'
import { applyRouteSeo } from '@/utils/seo'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'main-page',
      component: () => import('@/layout/main-page')
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: () => import('@/layout/about-us')
    },
    {
      path: '/business/profile/:id',
      name: 'business_profile',
      component: () => import('@/layout/business-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/edit-profile',
      name: 'edit-profile',
      component: () => import('@/layout/edit-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/how-it-works',
      name: 'how-it-works',
      component: () => import('@/layout/how-it-work')
    },
    {
      path: '/job/:id',
      name: 'job',
      component: () => import('@/layout/job-post'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/layout/login')
    },
    {
      path: '/my-jobs/',
      name: 'my-jobs',
      component: () => import('@/layout/my-jobs-talent'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/my-hires/',
      name: 'my-hires',
      component: () => import('@/layout/my-jobs-employer'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/e-wallet/',
      name: 'e-wallet',
      component: () => import('@/layout/my-e-wallet'),
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        const filter = to.query.filter
        const tab = to.query.tab
        if (!filter) {
          next({ path: '/e-wallet', query: { ...to.query, filter: E_WALLET_FILTER.ALL } })
        }
        if (!tab) {
          next({ path: '/e-wallet', query: { ...to.query, tab: E_WALLET_TAB.OVERVIEW } })
        }
        next()
      }
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('@/layout/find-jobs')
    },
    {
      path: '/notice-board',
      name: 'notice-board',
      component: () => import('@/layout/notice-board')
    },
    {
      path: '/post-job',
      name: 'post-job',
      component: () => import('@/layout/post-a-job')
    },
    {
      path: '/edit-job/:id',
      name: 'edit-job',
      component: () => import('@/layout/post-a-job'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/layout/privacy-policy')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/layout/new-password')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/layout/settings')
    },
    {
      path: '/business-account',
      name: 'business-account',
      component: () => import('@/layout/business-account')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: () => import('@/layout/sign-up')
    },
    {
      path: '/jobs/job-alert-settings',
      name: 'job-alert-settings',
      component: () => import('@/layout/alert-settings'),
      props: { parent: 'job-alert-settings' },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/talents/talent-alert-settings',
      name: 'talent-alert-settings',
      component: () => import('@/layout/alert-settings'),
      props: { parent: 'talent-alert-settings' },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/talents',
      name: 'talents',
      component: () => import('@/layout/browse-talents')
    },
    {
      path: '/talents/profile/:id',
      name: 'talent_profile',
      component: () => import('@/layout/talent-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/talents/profile/:id/edit/',
      name: 'edit-profile-talent',
      component: () => import('@/layout/edit-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/business/profile/:id/edit/',
      name: 'edit-profile-business',
      component: () => import('@/layout/edit-business-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/business/create-profile/',
      name: 'create-profile-business',
      component: () => import('@/layout/edit-business-profile'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () => import('@/layout/terms-of-service')
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import('@/layout/contact-us')
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('@/layout/message'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/zoom',
      name: 'zoom',
      component: () => import('@/layout/zoom'),
      meta: {
        requiresAuth: true
      }
    }
  ],
  mode: 'history'
})

let entryUrl = null

router.beforeEach(async (to, from, next) => {
  // we use await as this async request has to finish
  // before we can be sure
  await store.dispatch('checkAuth')
  let isLoggedIn = store.getters.getAuthenticated
  let pageName = to.name
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLoggedIn) {
      if (entryUrl) {
        const url = entryUrl
        entryUrl = null
        return next(url) // goto stored url
      } else {
        return next()
      }
    } else {
      next('/login')
    }
  } else {
    if ((pageName === 'sign-up' || pageName === 'login') && isLoggedIn) {
      next('/')
    } else {
      next()
    }
  }
})

router.afterEach(to => {
  applyRouteSeo(to)
})

export default router
